import { TID } from "@/lib/testIds";

/**
 * PURELIFE Roleplay brand wordmark — CSS recreation
 * Sostituibile in seguito con il file logo ufficiale (caricalo come
 * /app/frontend/public/purelife-logo.png e usa <img src="/purelife-logo.png" />)
 */
export const BrandLogo = ({ size = "md", showSub = true, className = "" }) => {
  const sizes = {
    xs: { main: "text-lg", sub: "text-[10px]" },
    sm: { main: "text-2xl", sub: "text-xs" },
    md: { main: "text-4xl", sub: "text-base" },
    lg: { main: "text-6xl", sub: "text-2xl" },
    xl: { main: "text-5xl sm:text-7xl lg:text-9xl", sub: "text-xl sm:text-3xl lg:text-4xl" },
  };
  const s = sizes[size] || sizes.md;

  return (
    <span
      data-testid={TID.nav.logoMark}
      className={`brand-wordmark ${className}`}
    >
      <span className={`brand-wordmark__main ${s.main}`}>PURELIFE</span>
      {showSub && (
        <span className={`brand-wordmark__sub ${s.sub}`}>Roleplay</span>
      )}
    </span>
  );
};

export default BrandLogo;
